import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { Impuestopro } from "./modalImppro";
import CartasAgentes from "../agentes/cartasAgentes";
import { Torta } from "../graficos/graficos";
import { formatMoneda } from "../../util/varios";
import { Toasts } from "../toasts";

const TablaImpuestopro = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accregproducc = JSON.parse(localStorage.getItem("accregproducc"));
  let municipios = [];

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "COD.",
      textAlign: "center",
    },
    {
      id: "nombre",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "NOMBRE / RAZÓN SOCIAL",
      textAlign: "center",
    },
    {
      id: "rif",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CED. / RIF. / SUC.",
      textAlign: "center",
    },
    {
      id: "nrolicencia",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "LICENCIA",
      textAlign: "center",
    },
    {
      id: "estatus",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ESTATUS",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const colores = [
    "#17a2b8",
    "#ffae00",
    "#dc3545",
    "#BDB76B",
    "#7B68EE",
    "#4B0082",
    "#00ffff",
    "#0080ff",
    "#0000ff",
    "#8000ff",
    "#ff00ff",
    "#ff0080",
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [expendedor, setExpendedor] = useState([]);
  const [represent, setRepresent] = useState();
  const [clasesms, setClasesms] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [ciudades, setCiudades] = useState();
  const [credito, setCredito] = useState();
  const [total, setTotal] = useState(0);
  const [activos, setActivos] = useState(0);
  const [inactivos, setInactivos] = useState(0);
  const [municipiosEx, setMunicipiosEx] = useState([]);
  const [municipiosData, setMunicipiosData] = useState([]);
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [totDeuda, setTotDeuda] = useState("0,00");
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const [datos, setDatos] = useState([]);
  const [colorG, setColorG] = useState([]);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  let el;
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    let st = "";
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            st = x.statusproduccion === "51" ? "activo" : "inactivo";
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nrolicenciaproduccion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              st.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const getExpendedores = () => {
    setActivate(true);

    let campos = `trim(a.nombre) as nombre, a.idagente, trim(a.rif) as rif, trim(a.nroresolucion) as nroresolucion
    , trim(a.nrolicencia) as nrolicencia, a.status, trim(a.nroresolucionmina) as nroresolucionmina
    , trim(a.nrolicenciamina) as nrolicenciamina, a.statusmina, trim(a.nroresolucionproduccion) as nroresolucionproduccion
    , trim(a.nrolicenciaproduccion) as nrolicenciaproduccion, a.statusproduccion, trim(a.nroresolucion1x500) as nroresolucion1x500
    , trim(a.nrolicencia1x500) as nrolicencia1x500, a.status1x500, a.municipio, a.ciudad, trim(m.nombre) as municipios, a.sucursal `;
    let nomtab =
      "agente as a inner join municipio as m on a.municipio=m.idmunicipio";
    let condi = `a.produccion=true and a.idtipoagente=5`;
    let orden = "idagente asc";

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let total = 0,
            activos = 0,
            inactivos = 0,
            conteo = 0,
            indice = 0;
          const idmunicipioss = [];
          const results = [];
          const element = [];
          const unicos = [];
          const color = [];

          if (response.data.length > 0) {
            setRecords(response.data);
            txtBuscador.current.focus();

            for (let i = 0; i < response.data.length; i++) {
              if (parseInt(response.data[i].statusproduccion) === 51) {
                idmunicipioss.push(response.data[i]);
              }
            }

            for (var i = 0; i < idmunicipioss.length; i++) {
              const elemento = idmunicipioss[i].municipios;

              for (let j = 0; j < response.data.length; j++) {
                if (
                  idmunicipioss[i].municipios === response.data[j].municipios &&
                  parseInt(response.data[j].statusproduccion) === 51
                ) {
                  conteo += 1;
                  if (indice !== i) {
                    indice = i;
                    conteo = 1;
                  }
                }
              }

              if (!unicos.includes(idmunicipioss[i].municipios)) {
                unicos.push(elemento);
                results.push(conteo);
                color.push(colores[i]);
                element.push({
                  nombre: idmunicipioss[i].municipios,
                  valor: conteo,
                  color: colores[i],
                });
              }
            }

            for (let i = 0; i < response.data.length; i++) {
              total += 1;
              if (parseInt(response.data[i].statusproduccion) === 51) {
                activos += 1;
              }
              if (parseInt(response.data[i].statusproduccion) === 52) {
                inactivos += 1;
              }
            }

            setTotal(total);
            setActivos(activos);
            setInactivos(inactivos);
            setColorG(color);
            setMunicipiosEx(unicos);
            setMunicipiosData(results);
            setDatos(element);
          } else {
            setRecords([]);
            txtBuscador.current.focus();
            setTotal(0);
            setActivos(0);
            setInactivos(0);
            setMunicipiosEx([]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const selectMunicipio = () => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let id = "18";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          municipios = response.data;
          getExpendedores();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const getExpendedor = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/agente/veragente/${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            setExpendedor(response.data);
            selectCiudad(response.data.municipio);
            seleccionarRepre(response.data);
          } else {
            seleccionarRepre(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudades(response.data);
          //setMostrar2(true)
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRepre = (data) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.reprelegal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.cedula > 0) {
            setRepresent(response.data);
            seleccionarClase(data);
          } else {
            seleccionarClase(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarClase = (data) => {
    let endpoint = `${op.conexion}/api/produccion/claseproduccionxagente/${data.idagente}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setClasesms(response.data);
            //setMostrar2(true);
            SelectDeudaAgenProd(data.idagente);
          } else {
            //setMostrar2(true);
            SelectDeudaAgenProd(data.idagente);
          }

          //setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectDeudaAgenProd = (idagente) => {
    let endpoint = `${
      op.conexion
    }/api/minas/deudas?idagente=${idagente}&fecha=${fechaSistema}&tabconf=${"configproduccion"}&condic=${"tipodeuda=2"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setTotDeuda(
            formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2)
          );
          setDeuda(deu);
          setHistorico(his);
        }
        setActivate(false);
        setMostrar2(true);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const gestionarExpendedor = (op, id) => (e) => {
    blanquear();
    if (op === 4) {
      if (accregproducc.substring(0, 1) !== "0") {
        setOperacion(4);
        getExpendedor(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accregproducc.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accregproducc.substring(2, 3) !== "0") {
        setOperacion(op);
        getExpendedor(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accregproducc.substring(3, 4) !== "0") {
        setOperacion(op);
        getExpendedor(id);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    getExpendedor();
  };

  function seleccionarCampos(idclass, descrip, codclass, alicuota) {
    let clases = [];
    if (clasesms.length > 0) {
      for (let i = 0; i < clasesms.length; i++) {
        if (idclass !== clasesms[i].idclaseproduccion) {
          clases.push(clasesms[i]);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "No puede Seleccionar la Misma Clase",
            icono: "informacion",
          });
        }
      }
    }
    clases.push({
      idclaseproduccion: idclass,
      descripcion: descrip,
      codigoclaseproduccion: codclass,
      alicuota: alicuota,
    });
    setClasesms(clases);
  }

  function eliminarCampos(idclass) {
    let clases = [];
    if (clasesms.length > 0) {
      for (let i = 0; i < clasesms.length; i++) {
        if (idclass !== clasesms[i].idclaseproduccion) {
          clases.push(clasesms[i]);
        }
      }
    }

    setClasesms(clases);
  }

  const blanquear = () => {
    setRepresent();
    setClasesms([]);
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    selectMunicipio();
    setActivate(true);
  }, []);

  const data = {
    labels: municipiosEx,
    leyend: true,
    datasets: [
      {
        label: "#",
        data: municipiosData,
        backgroundColor: colorG,
        borderColor: colorG,
        borderWidth: 1,
        hoverBorderWidth: 15,
      },
    ],
  };

  const options = {
    responsive: true,
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: true,
      text: `Municipios con Productores Activos: ${municipiosData.length}`,
    },
  };

  return (
    <div className="p-0" style={{ height: "100%", width: "100%", margin: 0 }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12" style={{ margin: 0 }}>
          <div className="col-md-8 py-3">
            <CartasAgentes
              total={total}
              nombre={"Productores"}
              activos={activos}
              inactivos={inactivos}
            />

            <div className="col-12 p-2">
              <div className="row col-12 d-flex justify-content-between">
                <input
                  type="text"
                  className=" col-3 form-control form-control-sm rounded-pill"
                  ref={txtBuscador}
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
                <div className="col-3 d-flex justify-content-end">
                  <button
                    onClick={gestionarExpendedor(1, "")}
                    className={
                      accregproducc.substring(1, 2) === "0"
                        ? "btn btn-sm btn-secondary rounded-circle"
                        : "btn btn-sm btn-primary rounded-circle"
                    }
                  >
                    <i className="fas fa-plus"></i>{" "}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer>
                <TblHead />
                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", alignItems: "center" }}
                        >
                          {item.idagente}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "270px",
                          }}
                        >
                          {item.nombre}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", alignItems: "center" }}
                        >
                          {item.rif + " - " + item.sucursal}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", alignItems: "center" }}
                        >
                          {item.nrolicenciaproduccion}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", alignItems: "center" }}
                        >
                          {item.statusproduccion === "51" ? (
                            <span className="text-success2 mayuscula fw-bold">
                              Activo
                            </span>
                          ) : (
                            <span className="text-danger2 mayuscula fw-bold">
                              Inactivo
                            </span>
                          )}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{ textAlign: "center", alignItems: "center" }}
                        >
                          <button
                            onClick={gestionarExpendedor(4, item.idagente)}
                            className={
                              accregproducc.substring(0, 1) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-info rounded-circle"
                            }
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>

                          <button
                            onClick={gestionarExpendedor(2, item.idagente)}
                            className={
                              accregproducc.substring(2, 3) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-warning rounded-circle"
                            }
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>

                          <button
                            onClick={gestionarExpendedor(3, item.idagente)}
                            className={
                              accregproducc.substring(3, 4) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-danger rounded-circle"
                            }
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
          <div className="col-md-4 py-3">
            <Torta data={data} height={200} options={options} datos={datos} />
          </div>
        </div>
      </div>
      <Impuestopro
        show={mostrar2}
        operacion={operacion}
        expendedor={expendedor}
        eliminarCampos={eliminarCampos}
        seleccionarCampos={seleccionarCampos}
        clasesm={clasesms}
        represent={represent}
        ciudades={ciudades}
        credito={credito}
        onHideCancela={handleCancela2}
        onHideRenderizar={selectMunicipio}
        tabdeuda={deuda}
        tabpago={historico}
        totdeuda={totDeuda}
      />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaImpuestopro;



// WEBPACK FOOTER //
// ./src/components/impuestoprodu/tablaIpmpro.js